import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchSingleRecordSuccess,
    resetState,
} from './club-management.action';
import { ClubManagement, CommunicationCategory, CommunicationStatus, CommunicationFile } from './club-management.model';

export interface ClubManagementRecordsState {
    listData: any[];
    singleData: ClubManagement;
    loading: boolean;
    error: any;
    total: number;
    statuses: CommunicationStatus[];
    categories: CommunicationCategory[];
    dummyId: string;
    files: CommunicationFile[];
}

export const initialState: ClubManagementRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0,
    statuses: [],
    categories: [],
    dummyId: "",
    files: []
};

export const clubManagementReducer = createReducer(
    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),

    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(fetchSingleRecordSuccess, (state, { dummyId, singleData, files, statuses, categories }) => {
        return { ...state, dummyId, singleData, files, statuses, categories, error: null };
    }),

    on(resetState, () => initialState)  // Reset action handler
);